import { memo, useCallback, useContext, useEffect } from "react";

import CircularLoader from "../../../components/loading/circularLoader";
import { DashBoardContext } from "../contexts/DashBoardContext";
import { useDashBoardFinanceiroService } from "../contexts/DashBoardFinanceiroContext";
import { ChartContainer, LoadingContainer } from "../styles/DashBoard";
import HorizontalBarChart from "./BarChart/HorizontalBarChart";
import ERPPieChart from "./PieChart/PieChart";

const BillsToReceiveChart = () => {
  const { defaultIntervalPeriodLabel } = useContext(DashBoardContext);
  const {
    billsChartsInfo,
    isBillToReceiveLoading,
    isBillToReceiveRefetchLoading,
    billToReceiveRefetch,
  } = useDashBoardFinanceiroService();

  const refresh = useCallback(async () => {
    setTimeout(async () => {
      await billToReceiveRefetch();
    }, 100);
  }, [billToReceiveRefetch]);

  useEffect(() => {
    refresh();
  }, [
    billsChartsInfo.billsToReceiveGroupPeriod,
    billsChartsInfo.companies,
    refresh,
  ]);

  const chartView = {
    bar: (
      <HorizontalBarChart
        label={
          defaultIntervalPeriodLabel[
            billsChartsInfo?.billsToReceiveGroupPeriod || "date"
          ].strInfo
        }
        closedLabel={"Recebido"}
        groupedDate={billsChartsInfo.billsToReceiveGroupPeriod}
        data={billsChartsInfo.billsToReceiveData}
      />
    ),
    pie: (
      <ERPPieChart
        closedLabel={"Recebido"}
        data={billsChartsInfo.billsToReceivePieChartData}
      />
    ),
  };

  if (isBillToReceiveLoading || isBillToReceiveRefetchLoading)
    return (
      <LoadingContainer>
        <CircularLoader />
      </LoadingContainer>
    );

  return (
    <ChartContainer>
      {chartView[billsChartsInfo.billsToReceiveChartView]}
    </ChartContainer>
  );
};

export default memo(BillsToReceiveChart);
